module.exports = __webpack_public_path__ + "media/assets/checkbox-b7f8754dab65e7078afba90cb2d9acbce3057e29d98b91b73907bf03000fd072.png";